import type { FaireProductEntity } from "../../entity_types/product";

export const p_chad2wxj78: FaireProductEntity = {
  token: "p_chad2wxj78",
  type: "product",
  name: "Dainty Geometric Triangle Stud Earrings in Stainless Steel",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/23fc9ef699c29602b5bc899e92727c79bc256779568c4392fb28269953946267.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/378657f68aa84bfd7efbfe04bb94d6ce35450aacd804b5bc768d8398cdd17259.png",
    "https://cdn.faire.com/fastly/14d50cb6a713da8cbb1b7e98d139bc50828d1f842e85c3c3f4d1c0a070d83868.png",
    "https://cdn.faire.com/fastly/0f2630353e868542934a806779aca11ec9d6901f327cef0372df4dcbff29cb99.png",
    "https://cdn.faire.com/fastly/e0f0ba21a7ba6425e25247d998bcca24309756604fe00041118f68a967023a04.png",
    "https://cdn.faire.com/fastly/d33c7e60eda613021443d70d89d64103bdaa4552696033db3dfb08a6952a9c7f.png",
  ],
  priceDollars: 10,
  description:
    "Description & Details\n\nEmbrace the beauty of simplicity and understated elegance with our carefully curated pieces. Each design in our collection is thoughtfully crafted to celebrate clean lines, subtle details, and the timeless appeal of minimalism.\n\n• Material: High Quality Stainless Steel ∙ Cubic Zirconia\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 8 x 7 mm each, sold as a pair\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:50.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
